export function getPartnerDisplayName(partner) {
  if (!partner) return ''

  return (
    partner.full_name?.trim() ||
    [partner.first_name, partner.last_name].filter(Boolean).join(' ').trim() ||
    partner.label?.trim() ||
    ''
  )
}
